import { createFileRoute } from '@tanstack/react-router';

import { UpdateClassPage } from '~features/classes/ui/update-class-page';

export const Route = createFileRoute('/_auth/_layout/classes/$classId/update')({
  component: UpdateClassPage,
});
